// extracted by mini-css-extract-plugin
export var contentCard = "bv_dW";
export var gridBase = "bv_dS";
export var gridElement = "bv_dX";
export var gridTumbleIn = "bv_dY";
export var heightAuto = "bv_dV";
export var heightFull = "bv_dT";